import UIComponent from "../../common/UIComponent";
import "./index.css";
const TENCENT_DELAY = 90;

export default class LiveShiftTime extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
    this.interfaces.on(VhallPlayer.LOADED, (e) => {
        this.timeBox.setAttribute("class", "vhallPlayer-time-box display");
    })

    this.interfaces.on(VhallPlayer.TIMEUPDATE, (e) => {
      this.shiftStartTime.innerText = this._formatTime(e.playedDate);
    })
  }

  init() {
    this.timeBox = document.createElement("div");
    this.timeBox.setAttribute("class", "vhallPlayer-time-box hide");

    // 时移直播播放时间
    this.shiftStartTime = document.createElement("span");
    this.shiftStartTime.setAttribute("class", "start-time");
    this.shiftStartTime.innerText = "00:00:00";

    this.timeBox.appendChild(this.shiftStartTime);

    this.insertElement(this.elementId, this.timeBox);
  }

  _secondToDate(result) {
    var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
    var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
    return result = h + ":" + m + ":" + s;
  }

  _formatTime(ms) {
    const format = new Date(ms).Format('yyyy-MM-dd hh:mm:ss');
    return format.split(' ')[1];
    // const h = now.getHours();
    // const m = now.getMinutes();
    // const s = now.getSeconds();
    // return `${h}:${m}:${s}`;
  }
}